import { render } from "./ZhTabSet.vue?vue&type=template&id=134b8658&scoped=true&ts=true"
import script from "./ZhTabSet.vue?vue&type=script&lang=ts"
export * from "./ZhTabSet.vue?vue&type=script&lang=ts"

import "./ZhTabSet.vue?vue&type=style&index=0&id=134b8658&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134b8658"]])

export default __exports__